import { useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { walletsAtom } from '@root/entities/wallet/atoms'
import {
  hiddenScrollbarCss,
  mediaMaxTablet,
  mediaMinTablet,
} from '@root/shared/ui-kit'

import { WalletSummaryItem } from './wallet-summary-item'

export const SummaryWalletList = () => {
  const [wallets] = useAtom(walletsAtom)

  return (
    <Root>
      {wallets.map((wallet, idx) => (
        <WalletSummaryItem key={idx} wallet={wallet} />
      ))}
    </Root>
  )
}

const Root = styled.div`
  border-top: 1px solid rgba(255 255 255 / 10%);
  padding-block: 22px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  overflow-y: auto;
  max-height: 100%;

  ${mediaMinTablet(css`
    display: grid;
    grid-template-columns: 1fr 1fr;
  `)}

  ${mediaMaxTablet(hiddenScrollbarCss)}
`
